<template>
    <el-card shadow="never">
        <template #header>
          <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
              <el-breadcrumb-item>公司列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="editbtn" @click="add">创建公司</el-button>
          </div>
        </template>
        <el-form :model="searchForm" inline label-width="120px">
          <el-form-item label="公司分类">
            <el-cascader
              v-model="searchForm.cates"
              :options="baseData.cateslist"
              :props="propss"
              clearable
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item label="关键词">
            <el-input v-model="searchForm.words" placeholder="公司名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="title" label="公司名称"/>
          <el-table-column prop="catagory_name" label="分类名称"/>
          <el-table-column prop="name" label="姓名"/>
          <el-table-column prop="phone" label="手机号码" width="120"/>
          <el-table-column prop="wxcode" label="微信号"/>
          <el-table-column prop="website" label="网址"/>
          <el-table-column prop="address" label="公司地址"/>
          <el-table-column prop="end_time" label="到期时间" width="180"/>
          <el-table-column prop="created_at" label="创建时间" width="180"/>
          <el-table-column prop="status" label="状态" width="90" >
            <template #default="scope">
              <el-text v-if="scope.row.status==0" type="danger">冻结</el-text>
              <el-text v-if="scope.row.status==1" type="warning">待审核</el-text>
              <el-text v-if="scope.row.status==2" type="success">正常</el-text>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="310" >
            <template #default="scope">
              <el-button size="small" @click="edit(scope.row.id)" type="primary">编辑</el-button>
              <el-button size="small" @click="showEndTimeBox(scope.row.id,scope.row.end_time)" type="warning">设置到期时间</el-button>
              <el-button size="small" @click="showlog(scope.row.id, scope.row.title)">记录</el-button>
              <el-button size="small" @click="del(scope.row.id)" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
      <el-dialog v-model="baseData.endTimeBox" title="设置到期时间" width="600px">
        <el-form :model="endTimeForm" label-width="80px">
          <el-form-item label="到期时间">
            <el-date-picker
                v-model="endTimeForm.end_time"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
              />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="endTimeForm.remark" autocomplete="off" :rows="2" type="textarea"/>
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="baseData.endTimeBox = false">取消</el-button>
            <el-button type="danger" @click="setEndTime()">提交</el-button>
          </div>
        </template>
      </el-dialog>
      <el-drawer v-model="baseData.showloglistbox">
        <template #header>
          <h4>{{baseData.showlogtitle}}</h4>
        </template>
        <template #default>
          <div>
            <el-timeline style="max-width: 600px">
              <el-timeline-item
                v-for="(activity, index) in baseData.loglist"
                :key="index"
                :timestamp="activity.created_at"
              >
                <p>{{ activity.remark }}</p>
                <p>操作人：{{ activity.username }}</p>
              </el-timeline-item>
            </el-timeline>
          </div>
        </template>
        <template #footer>
          <div style="flex: auto">
            <el-button type="primary" @click="baseData.showloglistbox = false">关闭</el-button>
          </div>
        </template>
      </el-drawer>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  const router = useRouter()
  const propss = {
    expandTrigger: 'hover' as const,
    value:'ID',
    label:'Title',
    children:'Children',
  }
  const searchForm:any = reactive({
    cate:"",
    cates:[],
    words:"",
    limit:10,
    page:1,
  })
  const endTimeForm:any = reactive({
    id:"",
    end_time:"",
    remark:"",
  })
  const baseData = reactive({
    loading:false,
    title:'',
    endTimeBox:false,
    cateslist:[],
    showloglistbox:false,
    showlogtitle:"",
    loglist:[],
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleChange = (value:any) => {
    searchForm.cate = value[value.length - 1]
  }
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    searchForm.cate = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const showlog = (id:string,title:string) => {
    baseData.showloglistbox = true
    baseData.showlogtitle = title
    api.companyApi.getLogList({id:id}).then((res:any)=>{
      if(res.code==200){
        baseData.loglist = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const showEndTimeBox = (id:string,end_time:string) => {
    baseData.endTimeBox = true
    endTimeForm.id = id
    endTimeForm.end_time = end_time
    endTimeForm.remark = ""
  }
  const setEndTime = () =>{
    api.companyApi.setEndTime(endTimeForm).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.endTimeBox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    localStorage.setItem('companyspage',searchForm.page);
    localStorage.setItem('companyscate',searchForm.cate);
    localStorage.setItem('companyswords',searchForm.words);
    localStorage.setItem('companyslimit',searchForm.limit);
    baseData.loading = true
    api.companyApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].Status = res.data.list[i].Status==1?true:false
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    router.push("/company/add");
  }
  const edit = (id:any) => {
    router.push("/company/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.companyApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCatesList = () => {
    baseData.loading = true
    api.companyApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.cateslist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const defaultProps = {
    children: 'children',
    label: 'catagory_name',
    value: 'catagoryid',
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('companyspage') ? parseInt(localStorage.getItem('companyspage')) : 1;
    searchForm.cate = localStorage.getItem('companyscate') ? localStorage.getItem('companyscate') : '';
    searchForm.words = localStorage.getItem('companyswords') ? localStorage.getItem('companyswords') : '';
    searchForm.limit = localStorage.getItem('companyslimit') ? parseInt(localStorage.getItem('companyslimit')) : 10;
    getList()
    getCatesList()
  })
  </script>